const ACLPermissionsResponseTypePolicy = {
  ACLPermissionsResponse: {
    keyFields: ({ uid, module }) => {
      /**
       * Currently only context is considered in uid as permission value is dependent on the context.
       * But, response is dependent on the module as well(permissions are filtered by module). So, we need to include module.
       *
       * Note: Technically, response also depends on the appType. But, on web, appType will be same for all queries.
       * So, we can ignore it for now.
       */
      return `${uid}_${module}`;
    },
  },
};

export default ACLPermissionsResponseTypePolicy;
